import {
  acceptForProcessingType,
  acceptForProcessingSuccessType,
  acceptForProcessingFailureType,
} from 'actions/Lots/acceptForProcessing';

const INITIAL_STATE = {
  isPending: false,
};

const acceptForProcessingReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case acceptForProcessingType:
      return {
        isPending: true,
      };
    case acceptForProcessingSuccessType:
    case acceptForProcessingFailureType:
      return {
        isPending: false,
      };
    default:
      return state;
  }
};

export { acceptForProcessingReducer };
